import * as THREE from 'three';
import pnoise from 'glsl-noise/periodic/3d.glsl';

const shader = THREE.ShaderLib.standard;

let vert = shader.vertexShader;
let frag = shader.fragmentShader;

const vert_head = `
    uniform sampler2D uTexture;
    uniform float uNoise;
    uniform float uTime;
    
    varying float vIntersected;
    varying vec3 vPosition;
    varying vec2 vUv;
    
    ${pnoise}
`;

const project_vertex = `
    vUv = uv;
    
    vec4 mvPosition = vec4(transformed, 1.);
    
    // DISTORTING BUBBLE
    mvPosition.z += pnoise((transformed * .3 + sin(uTime)) * uNoise, vec3(50.));
    
    #ifdef USE_INSTANCING
        mvPosition = instanceMatrix * mvPosition;
    #endif
    mvPosition = modelViewMatrix * mvPosition;
    gl_Position = projectionMatrix * mvPosition;
`;

const fog_vertex = `
    #include <fog_vertex>
    vPosition = mvPosition.xyz;
`;

const color_fragment = `
  vec4 tex = texture2D(uTexture, vUv) * vec4(.35, .35, .35, 1.);
  diffuseColor.rgba = tex.rgba;
`;

const dithering_fragment = `
    #include <dithering_fragment>
    
    //CUT CIRCLE
    float dist = length(uIntersectPoint.xyz - vPosition.xyz);
    float circle = smoothstep(uHoverRadius - 0.4, uHoverRadius + 0.3, dist);
    
    gl_FragColor = vec4(gl_FragColor.xyz, circle - .05);
`;

const frag_head = `
    uniform sampler2D uTexture;
    uniform float uTime;
    uniform vec3 uIntersectPoint;
    uniform float uHoverRadius;
    
    varying vec2 vUv;
    varying vec3 vPosition;
`;

vert = vert.replace('#include <project_vertex>', project_vertex);
vert = vert.replace('#include <fog_vertex>', fog_vertex);
vert = vert.replace('#include <project_vertex>', project_vertex);
export const vertex = vert_head + vert;

frag = frag.replace('#include <color_fragment>', color_fragment);
frag = frag.replace('#include <dithering_fragment>', dithering_fragment);
export const fragment = frag_head + frag;
